import React from 'react'
import { SvgProps } from './types'

const DecreaseIcon = ({ width, height, fill }: SvgProps) => {
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      fill={fill ?? 'currentColor'}
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="m22 5c0-.478-.379-1-1-1h-18c-.62 0-1 .519-1 1v14c0 .621.52 1 1 1h18c.478 0 1-.379 1-1zm-11.5 13.5h-7v-4h7zm1.5 0v-4.5c0-.478-.379-1-1-1h-7.5v-7.5h17v13zm2.5-8.057v-1.243c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.05c0 .414.336.75.75.75h3.033c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.218l3.198-3.198c.292-.293.292-.768 0-1.061-.293-.292-.768-.292-1.061 0z"
        fillRule="nonzero"
      />
    </svg>
  )
}

export default DecreaseIcon
